import type { Meta, StoryObj } from "@storybook/web-components";
import { withActions } from "@storybook/addon-actions/decorator";
import { CreateServiceCase, CreateServiceCaseProps } from "./CreateServiceCase";
import { NOTIFICATION_TYPES } from "../src/api/publicApi/notificationType";

// More on how to set up stories at: https://storybook.js.org/docs/writing-stories
const meta = {
    title: "CreateServiceCase",
    decorators: [withActions],
    component: "mf-create-service-case",
    tags: ["autodocs"],
    render: (args) => CreateServiceCase(args),
    argTypes: {
        multipleSteps: {
            control: { type: "boolean" }
        },
        fileUpload: {
            control: { type: "boolean" }
        },
        locale: {
            control: { type: "select" },
            options: ["de-DE", "en-US"]
        },
        prefillData: {
            control: { type: "object" }
        },
        onMfServiceCaseSubmit: {
            action: "case-create"
        },
        onMfServiceCaseCancel: {
            action: "case-cancel"
        },
        disableSilentAuth: {
            control: { type: "boolean" }
        },
        env: {
            control: { type: "select" },
            options: ["dev", "qa", "prod"]
        },
        legacyApi: {
            control: { type: "boolean" }
        }
    }
} satisfies Meta<CreateServiceCaseProps>;

export default meta;
type Story = StoryObj<CreateServiceCaseProps>;

export const OnePage: Story = {
    args: {
        multipleSteps: false,
        fileUpload: true,
        locale: "de-DE",
        disableSilentAuth: false,
        env: "qa",
        legacyApi: false
    }
};

export const MultiStep: Story = {
    args: {
        multipleSteps: true,
        fileUpload: true,
        locale: "en-US",
        disableSilentAuth: false,
        env: "qa",
        legacyApi: false
    }
};

export const WithContactData: Story = {
    args: {
        multipleSteps: false,
        locale: "de-DE",
        prefillData: {
            notificationType: null,
            productData: {
                assetId: null,
                errorNumbers: []
            },
            softwareData: {
                productNumber: null,
                softwareModule: null,
                softwareType: null,
                isInstallationProblem: null,
                isLicenseIssue: null,
                softwareProblemClassification: null
            },
            callBackContact: {
                salutation: 2,
                firstName: "Thom",
                lastName: "Mustermann",
                email: "example@trumpf.com",
                phone: "+49123456789"
            }
        },
        disableSilentAuth: false,
        env: "qa",
        legacyApi: false
    }
};

export const WithMachineStopData: Story = {
    args: {
        multipleSteps: false,
        locale: "de-DE",
        prefillData: {
            notificationType: NOTIFICATION_TYPES.MACHINE_STOP,
            productData: {
                assetId: "TWDEDEMO066",
                errorNumbers: ["1234.5678", "ABCD.1234"]
            },
            softwareData: {
                productNumber: "9TWDEDEMOS415",
                softwareModule: "Laser",
                softwareType: "TruTops",
                isInstallationProblem: true,
                isLicenseIssue: true,
                softwareProblemClassification: "fault"
            },
            callBackContact: {
                salutation: 2,
                firstName: "Thom",
                lastName: "Mustermann",
                email: "example@trumpf.com",
                phone: "+49123456789"
            }
        },
        disableSilentAuth: false,
        env: "dev",
        legacyApi: false
    }
};

export const WithSoftwareData: Story = {
    args: {
        multipleSteps: false,
        locale: "de-DE",
        prefillData: {
            notificationType: NOTIFICATION_TYPES.PROGRAMMING_SOFTWARE,
            productData: {
                assetId: "TWDEDEMO066",
                errorNumbers: ["1234.5678", "ABCD.1234"]
            },
            softwareData: {
                productNumber: "9TWDEDEMOS415",
                softwareModule: "Laser",
                softwareType: "TruTops",
                isInstallationProblem: false,
                isLicenseIssue: true,
                softwareProblemClassification: "fault"
            },
            callBackContact: {
                salutation: 2,
                firstName: "Thom",
                lastName: "Mustermann",
                email: "example@trumpf.com",
                phone: "+49123456789"
            }
        },
        disableSilentAuth: false,
        env: "dev",
        legacyApi: false
    }
};
